export default __webpack_public_path__ + "static/media/iconMeeting.e2dbe825.png";